const UUID_TAIL = /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i

/** A title as a short link name: lowercase words joined by dashes, accents dropped. */
export function slugify(input: string): string {
  return input
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60)
}

/** `/events/{kebab-title}-{uuid}` — the uuid is the real lookup key. */
export function toSlug(title: string, id: string): string {
  const head = slugify(title)
  return head ? `${head}-${id}` : id
}

/**
 * Pull the trailing UUID out of a slug. Title segments may contain hyphens, so
 * we anchor on the canonical UUID shape rather than splitting on `-`.
 */
/** Whether a path segment is a bare event or listing id rather than a link name. */
export function isUuid(value: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)
}

/** The path segment of an event page: its short link name, else title plus id. */
export function eventPathSegment(event: {
  id: string
  title: string
  slug?: string | null
}): string {
  return event.slug || toSlug(event.title, event.id)
}

export function parseId(slug: string): string | null {
  const match = slug.match(UUID_TAIL)
  return match ? match[1] : null
}
